import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { useCallback, useEffect, useState } from 'react';

const SLIDES = [
  'https://image.beholos.com/fit-in/1600x750/img/fitness-pass-v2/life/personal-training/move001.jpg',
  'https://image.beholos.com/fit-in/1600x750/img/fitness-pass-v2/life/personal-training/relax001.jpg',
  'https://image.beholos.com/fit-in/1600x750/img/fitness-pass-v2/life/personal-training/play001.jpg',
  'https://image.beholos.com/fit-in/1600x750/img/fitness-pass-v2/life/personal-training/eat001.jpg',
  'https://image.beholos.com/fit-in/1600x750/img/fitness-pass-v2/life/personal-training/prosper001.jpg'
]

export const Banners = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true },
    [Autoplay({ delay: 4000, stopOnInteraction: false })]
  )
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([])

  const onSelect = useCallback(() => {
    if (!emblaApi) return
    setSelectedIndex(emblaApi.selectedScrollSnap())
  }, [emblaApi])

  useEffect(() => {
    if (!emblaApi) return
    setScrollSnaps(emblaApi.scrollSnapList())
    emblaApi.on('select', onSelect)
    onSelect()
  }, [emblaApi, onSelect])

  return (
    <div className="overflow-hidden relative" ref={emblaRef}>
      <div className="flex">
        {SLIDES.map((url, index) => (
          <div
            key={index}
            className="min-w-full h-full relative py-25 bg-no-repeat bg-cover min-h-[calc(100vh-80px)] md:min-h-[auto]"
            style={{ backgroundImage: `url(${url})` }}
          >
            <div className="absolute inset-0 bg-black/30 z-0" />

            <div className="relative z-10 flex items-center h-full px-8">
              <div className="space-y-4 max-w-lg">
                <div className="uppercase font-bold text-md text-holos">
                  Programas o retos
                </div>
                <h2 className="text-5xl font-medium text-white font-juana italic">
                  Prueba un programa online guiado
                </h2>
                <h5 className="text-xl leading-normal text-white font-juana">
                  ¿No sabes como empezar? Nuestros programas incluyen un plan de videos pre-seleccionados según tus objetivos para cada día. Programas disponibles desde 3 días hasta 8 semanas.
                </h5>
                <div>
                  <a
                    href="#lista"
                    className="inline-block bg-holos-dark text-white uppercase text-center px-6 py-3 rounded w-full max-w-xs"
                  >
                    Ver programas o retos
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {scrollSnaps.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full transition-all ${index === selectedIndex ? 'bg-holos-dark' : 'bg-gray-300'
              }`}
            onClick={() => emblaApi?.scrollTo(index)}
          />
        ))}
      </div>
    </div>
  )
}